




import { EVENTS, SUBMODULES_PATHS } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

const typingStepDurationInMs = 50;
const deletingStepDurationInMs = 25;
const delayDurationInMs = 250;

// TODO - Remove this component when the placeholder animation is available in the base project
@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.core, ['inputQuery'])
  }
})
export default class CdlSearchPlaceholder extends Vue {
  inputQuery: string;
  placeholderAlternatives = Object.values(this.$x.messages.custom.inputPlaceholderAlternatives) as string[];

  currentPlaceholder = '';
  currentCharIndex: number;

  numberCharDiffDelete: number;

  currentAlternativeIndex: number;
  currentAlternative: string;

  timeouts = [];

  mounted() {
    this.$x.on(EVENTS.OpenEmpathyX).subscribe(() => this.reset());
    this.$x.on(EVENTS.InputQueryChanged).subscribe(() => this.reset());
    this.$x.on(EVENTS.ClearInputQuery).subscribe(() => this.reset());
  }

  private reset() {
    if (!this.inputQuery) {
      this.clearTimeouts();
      this.currentPlaceholder = '';
      this.currentCharIndex = 0;
      this.currentAlternativeIndex = 0;
      this.currentAlternative = this.placeholderAlternatives[this.currentAlternativeIndex];
      this.typing();
    }
  }

  private typing() {
    this.currentPlaceholder += this.currentAlternative.charAt(this.currentCharIndex);
    this.currentCharIndex++;

    if (this.currentCharIndex < this.currentAlternative.length) {
      this.pushTimeout(this.typing, typingStepDurationInMs);
    } else {
      this.currentAlternativeIndex++;
      if (this.currentAlternativeIndex < this.placeholderAlternatives.length) {
        this.calculateCharactersToDelete();
      }
    }
  }

  private calculateCharactersToDelete() {
    const nextAlternative = this.placeholderAlternatives[this.currentAlternativeIndex];
    for (let i = 0; i < this.currentAlternative.length; i++) {
      if (this.currentAlternative.charAt(i) !== nextAlternative.charAt(i)) {
        this.numberCharDiffDelete = this.currentAlternative.length - i;
        this.pushTimeout(this.deleting, delayDurationInMs);
        break;
      }
    }
  }

  private deleting() {
    this.currentCharIndex--;
    this.numberCharDiffDelete--;
    this.currentPlaceholder = this.currentPlaceholder.slice(0, -1);

    if (this.numberCharDiffDelete !== 0) {
      this.pushTimeout(this.deleting, deletingStepDurationInMs);
    } else {
      this.currentAlternative = this.placeholderAlternatives[this.currentAlternativeIndex];
      this.typing();
    }
  }

  private pushTimeout(operation: () => void, timeout: number) {
    this.timeouts.push(setTimeout(() => operation(), timeout));
  }

  private clearTimeouts() {
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    this.timeouts = [];
  }
}
